import React, { useMemo } from 'react';
import { useSelector } from 'react-redux';
import { isMobile } from 'react-device-detect';
import { Link } from 'react-router-dom';
import moment from 'moment';
import { Button } from 'src/components/Button';
import { FloatButton } from 'src/components/FloatButton';
import { getIsEditingForms, getHosLogExemptStatus } from 'src/features/hosLogs/store';

import ArrowIcon from 'src/assets/layout/navigation/arrow.svg';
import { CertifiedIcon, UncertifiedIcon } from 'src/assets/hosLogs/hosLog';
import { HosLogObject } from 'src/features/hosLogs/types';

import './LogHeader.scss';

interface Props {
  logItemDate: string;
  selectedHosLog: HosLogObject;
  onShowCertifyConfirmation: () => void;
}
export const LogHeader: React.FC<Props> = ({
  logItemDate,
  selectedHosLog,
  onShowCertifyConfirmation,
}) => {
  const currentDate = useMemo(() => {
    return moment(selectedHosLog.logDate).isSame(moment(), 'day');
  }, [selectedHosLog.logDate]);

  const isEditingForms = useSelector(getIsEditingForms);
  const exemptStatus = useSelector(getHosLogExemptStatus);

  const renderStatus = useMemo(
    () => (): JSX.Element => {
      const statusClassName = selectedHosLog.certifiedStatus
        ? 'certified-status'
        : 'uncertified-status';
      const status = selectedHosLog.certifiedStatus ? 'Certified' : 'Uncertified';
      return <span className={statusClassName}>{status}</span>;
    },
    [selectedHosLog],
  );

  const renderFloatButton = (): JSX.Element | false => {
    return (
      !isEditingForms &&
      !exemptStatus &&
      selectedHosLog.certifiedStatus === 0 && (
        <FloatButton
          className="confirm-float-button"
          title="Certify Log"
          onClick={onShowCertifyConfirmation}
          disabled={currentDate}
        />
      )
    );
  };

  return (
    <div className="hos-log-header">
      {isMobile && (
        <Link to="/hos-logs">
          <Button title="Back" icon={ArrowIcon} className="button-back" />
        </Link>
      )}
      <div className="date-period">{logItemDate}</div>
      {!exemptStatus && (
        <div className="certified">
          <img
            className="certified-icon"
            src={selectedHosLog.certifiedStatus ? CertifiedIcon : UncertifiedIcon}
            alt="certifyLogIcon"
          />
          {renderStatus()}
        </div>
      )}
      {renderFloatButton()}
    </div>
  );
};
